import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store/store";
import { UserMessageType } from "../../enums/UserMessageType";

export interface IUserMessage {
    message: string;
    type: UserMessageType;
    date: Date;
    markedAsRead: boolean;
    firstName: string;
}
export interface IClientBankMessage {
    message:string;
    date:Date;
    status:number;
    userId:string;
    requestId:string
}
interface IUserMessageState {
    messages: IUserMessage[];
    clientBankMessages:IClientBankMessage[]
}

const initialState: IUserMessageState = {
    messages: [],
    clientBankMessages:[]
};

export const userMessageSlice = createSlice({
    name: "userMessage",
    initialState,
    reducers: {
        addMessage: (state, action) => {
            state.messages.push({ ...action.payload, markedAsRead: false });
        },
        markAllAsRead: (state, action) => {
            state.messages.forEach((m) => (m.markedAsRead = true));
        },
        addClientBanksMessage:(state, action)=>{
            state.clientBankMessages.push({...action.payload})
        }
    }
});

// const sortedDesc = arr1.sort(
//     (objA, objB) => objB.date.getTime() - objA.date.getTime(),
// );

export const { addMessage, markAllAsRead, addClientBanksMessage } = userMessageSlice.actions;

export const selectUserMessages = (state: RootState) => {
    const userMessages: IUserMessage[] = [...state.userMessages.messages];
    return userMessages.sort((objA, objB) => objB.date.getTime() - objA.date.getTime());
};

export const userMessages = userMessageSlice.reducer;
